/**
 * DEFINITIONS
 * A Publisher (service or otherwise) represents an individual publisher, like Houston News & Weather
 */
export const PUBLISHER_SETTINGS_ORIGIN = {
    TEMPLATE: "TEMPLATE",
    ORG: "ORG_SETTINGS"
};
/**
 * @param servicePublisherChannel: a publisher channel obtained from the backend/adhering to ServicePublisherChannel.
 * @return: an equivalent object formatted to the PublisherChannel interface.
 */
export const servicePublisherChannelToPublisherChannel = (servicePublisherChannel) => {
    return {
        name: servicePublisherChannel.name,
        excluded: servicePublisherChannel.excluded
    };
};
/**
 * @param publisher: a publisher obtained from the frontend/adhering to Publisher.
 * @return: an equivalent object formatted to the ServicePublisher interface.
 */
export const publisherToServicePublisher = (publisher) => {
    return {
        id: publisher.id,
        name: publisher.name.trim(),
        parent: publisher.parent,
        parent_name: publisher.parentName,
        bundles: publisher.bundles?.map((el) => ({
            id: el.id
        })),
        cap: Math.trunc(publisher.cap || 0),
        last_update: publisher.updated ? publisher.updated.toISOString() : undefined
        // rtbImps is missing here since we should never be sending it to the backend
    };
};
/**
 * @param publisher: a publisher obtained from the backend/adhering to ServicePublisher.
 * @return: an equivalent object formatted to the Publisher interface.
 */
export const servicePublisherToPublisher = (publisher) => {
    return {
        id: publisher.id,
        name: publisher.name,
        parent: publisher.parent,
        parentName: publisher.parent_name,
        bundles: publisher.bundles?.map((el) => ({
            id: el.id
        })),
        cap: publisher.cap,
        updated: publisher.last_update ? new Date(publisher.last_update) : undefined,
        rtbImps: publisher.rtbImps
    };
};
//# sourceMappingURL=publisher.js.map